import React from "react";
import Checkbox, { checkboxClasses } from "@mui/material/Checkbox";
import { BORDER_COLOR, RED_COLOR } from "../../../theme/colors";

const RedCheckBox = ({ padding,...props }) => {


  return (
    <Checkbox
     
      {...props}
      sx={{
        color: BORDER_COLOR,
        [`&.${checkboxClasses.indeterminate},&.${checkboxClasses.checked}`]: {
          color: RED_COLOR,
        },
        padding: padding ? padding :  "8px 5px",
      }}
    
      size="small"
    />
  );
};

export default RedCheckBox;
